import React, { useState } from 'react';
import { BASE_URL } from "../../helpers/api";

export default function NewsletterForm({ label, btnText, btnArrowUrl }) {
  const [email, setEmail]         = useState("");
  const [loading, setLoading]     = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [error, setError]         = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    // Email validation
    if (!email.trim()) {
      setError("Email is required");
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError("Enter a valid email address");
      return;
    }

    setLoading(true);

    try {
      const res  = await fetch(`${BASE_URL}/subscribe`, {
        method:  "POST",
        headers: { "Content-Type": "application/json" },
        body:    JSON.stringify({ email, timezone: Intl.DateTimeFormat().resolvedOptions().timeZone }),
      });

      const data = await res.json();

      if (data.success) {
        setShowPopup(true);
        setEmail("");
      } else {
        setError(data.message || "Something went wrong.");
      }
    } catch (err) {
      setError("Server error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* ✅ Success Popup */}
{showPopup && (
  <div style={{
    position: 'fixed',
    top: 0, left: 0,
    width: '100%', height: '100%',
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999
  }}>
    <div style={{
      position: 'relative',          // ✅ needed for × button
      backgroundColor: '#fff',
      borderRadius: '16px',
      padding: '40px',
      maxWidth: '420px',
      width: '90%',
      textAlign: 'center',
      boxShadow: '0 10px 40px rgba(0,0,0,0.15)'
    }}>

      {/* ✅ × button top right */}
      <button
        onClick={() => setShowPopup(false)}
        style={{
          position: 'absolute', top: '10px', right: '10px',
          background: 'transparent', border: 'none',
          fontSize: '22px', cursor: 'pointer', color: 'gray', fontWeight: 'normal',
        }}
      >
        ×
      </button>

      <div style={{ fontSize: '50px', marginBottom: '12px' }}></div>
      <h2 style={{
        color: '#0a6cff',
        fontSize: '22px',
        marginBottom: '10px',
        fontFamily: 'Arial, sans-serif'
      }}>
        Thank You for Subscribing!
      </h2>
      <p style={{
        color: '#555',
        fontSize: '14px',
        lineHeight: '1.6',
        marginBottom: '24px'
      }}>
        You will now receive the latest health tips, updates and news from <strong>Medayus Team</strong>!
      </p>

    </div>
  </div>
)}

      {/* ✅ Newsletter Form */}
      {label && <p>Your Email</p>}
      <form onSubmit={handleSubmit} className="cs_newsletter_form">
        <input
          type="text"
          className="cs_form_field"
          placeholder="example@email.com"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
            setError("");
          }}
          disabled={loading}
        />
        <button type="submit" className="cs_btn cs_style_1" disabled={loading}>
          <span>{loading ? "Subscribing..." : btnText}</span>
          <i>
            <img src={btnArrowUrl} alt="Icon" />
            <img src={btnArrowUrl} alt="Icon" />
          </i>
        </button>
      </form>

      {/* Error message */}
      {error && (
        <p style={{
          color: 'red',
          fontSize: '12px',
          marginTop: '6px'
        }}>
           {error}
        </p>
      )}
    </>
  );
}